import { authPost, doPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function checkMemberList(params) {
  return authPost(`${baseUrl}/Agent2.ashx`, params);
}

export function memberTelegramUnbind(params) {
  return authPost(`${baseUrl}/Agent2.ashx`, params);
}

export function removeMemberPromotion(params, isFastLink) {
  if (isFastLink) return doPost(`${baseUrl}/Agent12.ashx`, params);
  return authPost(`${baseUrl}/Agent12.ashx`, params);
}

export function checkMemberGameList(params, isFastlink) {
  if (isFastlink) return doPost(`${baseUrl}/Agent4.ashx`, params);
  return authPost(`${baseUrl}/Agent4.ashx`, params);
}
export function checkMemberReportList(params) {
  return authPost(`${baseUrl}/Agent5.ashx`, params);
}
export function checkMemberrTelcoNGatewayList(params) {
  return authPost(`${baseUrl}/Agent6.ashx`, params);
}
export function changeMemberPassword(params, isFastLink) {
  if (isFastLink) return doPost(`${baseUrl}/Agent8.ashx`, params);
  return authPost(`${baseUrl}/Agent8.ashx`, params);
}
export function memberGameLogReport(params) {
  return authPost(`${baseUrl}/Agent9.ashx`, params);
}
export function vBossReport(params) {
  return authPost(`${baseUrl}/Agent10.ashx`, params);
}
